export default "/react/telegramAds-22466528.svg";